import type {StagesetStarterCategory} from './types';

export const START_FROM_SCRATCH_CATEGORY: StagesetStarterCategory = {
    id: 'START_FROM_SCRATCH',
    title: 'Start from scratch',
    collection: [
        {
            type: 'START_FROM_SCRATCH',
            name: 'Start from scratch',
            description:
                'Start from a clean slate and shape your pipeline around your company goals',
        },
    ],
};

export const DEFAULT_CATEGORIES: StagesetStarterCategory[] = [
    START_FROM_SCRATCH_CATEGORY,
    {
        id: 'COPY_EXISTING',
        title: 'Copy from existing pipeline',
        collection: [
            {
                type: 'COPY_EXISTING',
                name: 'Copy from existing pipeline',
                description: 'Duplicate a pipeline that was previously created by your team',
            },
        ],
    },
];
